var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "bg-secondary-3 rounded p-3 px-4" },
        [
          _c(
            "div",
            { staticClass: "row" },
            [
              _c("icon-view", {
                staticClass: "col",
                attrs: {
                  icon: "fas fa-file-search",
                  "icon-background": "#fff",
                  "icon-color": "#ff7058",
                  "icon-size": "14px",
                  title: "Búsqueda de Estudiante"
                }
              })
            ],
            1
          ),
          _c("validation-observer", { ref: "searchServiceRef" }, [
            _c("div", { staticClass: "row mt-3" }, [
              _c(
                "div",
                { staticClass: "col-12 col-md-4 mb-2" },
                [
                  _c("validation-provider", {
                    attrs: { rules: "required" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function({ errors }) {
                          return [
                            _c("custom-drop-down", {
                              attrs: {
                                "custom-error-msg":
                                  "Favor seleccion un año académico.",
                                error: errors[0],
                                fieldkey: "id",
                                fieldname: "description",
                                options: _vm.years,
                                placeholder: "Seleccione"
                              },
                              model: {
                                value: _vm.search.academicYear,
                                callback: function($$v) {
                                  _vm.$set(_vm.search, "academicYear", $$v)
                                },
                                expression: "search.academicYear"
                              }
                            })
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col-12 col-md-4 mb-3" },
                [
                  _c("validation-provider", {
                    attrs: { rules: "required" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function({ errors }) {
                          return [
                            _c("custom-input", {
                              attrs: {
                                "custom-error-msg": "",
                                error: errors[0],
                                icon: "fa fa-search orange-icon",
                                "left-icon": true,
                                placeholder: "Escribir Número de SIE o Referido"
                              },
                              model: {
                                value: _vm.search.SieOrReferralNumber,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.search,
                                    "SieOrReferralNumber",
                                    $$v
                                  )
                                },
                                expression: "search.SieOrReferralNumber"
                              }
                            }),
                            errors[0]
                              ? _c("custom-error", {
                                  attrs: {
                                    message:
                                      "Favor entrar un número de referido o SIE.",
                                    variant: "no-border ml-4"
                                  }
                                })
                              : _vm._e()
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col-md-2 search-button-container" },
                [
                  _c(
                    "action-button",
                    {
                      staticClass: "success",
                      attrs: { i: "fa fa-search" },
                      on: { click: _vm.onSearchHandler }
                    },
                    [_vm._v(" Buscar ")]
                  )
                ],
                1
              )
            ])
          ]),
          _vm.students.length > 0 && _vm.searched
            ? _c("custom-separator", {
                staticClass: "pt-3 my-4",
                attrs: { text: "Resultado de Búsqueda" }
              })
            : _vm._e(),
          _c(
            "div",
            { ref: "studentsList" },
            _vm._l(_vm.students, function(item, index) {
              return _c(
                "div",
                {
                  key: `${_vm.studentItemsClassname}-${index}-${Math.random()}`,
                  staticClass: "row student-row bg-white p-3 rounded mb-3",
                  class: `${_vm.studentItemsClassname}-${index}`
                },
                [
                  _c(
                    "div",
                    { staticClass: "col-6 col-md-2 mb-3 d-none d-md-block" },
                    [
                      _c("div", { staticClass: "student-row__label" }, [
                        _vm._v("Nombre del Estudiante:")
                      ]),
                      _c("span", { staticClass: "student-row__info" }, [
                        _vm._v(
                          " " +
                            _vm._s(item.studentSieId) +
                            " - " +
                            _vm._s(item.studentFullName) +
                            " "
                        )
                      ])
                    ]
                  ),
                  _c(
                    "div",
                    { staticClass: "col-6 col-md-2 mb-3 d-none d-md-block" },
                    [
                      _c("div", { staticClass: "student-row__label" }, [
                        _vm._v(" Referido: ")
                      ]),
                      _c("span", { staticClass: "student-row__info" }, [
                        _vm._v(" " + _vm._s(item.referralNumber) + " ")
                      ])
                    ]
                  ),
                  _c(
                    "div",
                    { staticClass: "col-6 col-md-2 mb-3 d-none d-md-block" },
                    [
                      _c("div", { staticClass: "student-row__label" }, [
                        _vm._v(" Vigencia: ")
                      ]),
                      _c(
                        "span",
                        { staticClass: "student-row__info text-nowrap" },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.formatDate(
                                  item.effectiveDateFrom.split(" ")[0]
                                )
                              ) +
                              " - " +
                              _vm._s(
                                _vm.formatDate(
                                  item.effectiveDateTo.split(" ")[0]
                                )
                              ) +
                              " "
                          )
                        ]
                      )
                    ]
                  ),
                  _c(
                    "div",
                    { staticClass: "col-6 col-md-2 mb-3 d-block d-md-none" },
                    [
                      _c("div", { staticClass: "student-row__label" }, [
                        _vm._v("Nombre del Estudiante:")
                      ]),
                      _c("span", { staticClass: "student-row__info" }, [
                        _vm._v(
                          " " +
                            _vm._s(item.studentSieId) +
                            " - " +
                            _vm._s(item.studentFullName) +
                            " "
                        )
                      ])
                    ]
                  ),
                  _c(
                    "div",
                    { staticClass: "col-6 col-md-2 mb-3 d-block d-md-none" },
                    [
                      _c("div", { staticClass: "student-row__label" }, [
                        _vm._v(" Referido: ")
                      ]),
                      _c("span", { staticClass: "student-row__info" }, [
                        _vm._v(" " + _vm._s(item.referralNumber) + " ")
                      ])
                    ]
                  ),
                  _c(
                    "div",
                    { staticClass: "col-6 col-md-2 mb-3 d-block d-md-none" },
                    [
                      _c("div", { staticClass: "student-row__label" }, [
                        _vm._v(" Vigencia: ")
                      ]),
                      _c("span", { staticClass: "student-row__info" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.formatDate(
                                item.effectiveDateFrom.split(" ")[0]
                              )
                            ) +
                            " " +
                            _vm._s(
                              _vm.formatDate(item.effectiveDateTo.split(" ")[0])
                            ) +
                            " "
                        )
                      ])
                    ]
                  ),
                  _c("div", { staticClass: "col-6 col-md-2 mb-3" }, [
                    _c("div", { staticClass: "student-row__label" }, [
                      _vm._v(" Tipo de Servicio: ")
                    ]),
                    _c("span", { staticClass: "student-row__info" }, [
                      _vm._v(" " + _vm._s(item.disciplineTypeName) + " ")
                    ])
                  ]),
                  _c("div", { staticClass: "col-12 col-md-2 mb-3" }, [
                    _c("div", { staticClass: "student-row__label" }, [
                      _vm._v(" Proveedor: ")
                    ]),
                    _c("span", { staticClass: "student-row__info" }, [
                      _vm._v(" " + _vm._s(item.companyName) + " ")
                    ])
                  ]),
                  _c(
                    "div",
                    {
                      staticClass:
                        "col-12 col-md-2 mt-3 d-flex justify-content-center align-items-start"
                    },
                    [
                      _c(
                        "action-button",
                        {
                          staticClass: "outline-success py-1 w-100",
                          attrs: { i: "fa fa-check" },
                          on: {
                            click: function($event) {
                              return _vm.onSelectHandler(item, index)
                            }
                          }
                        },
                        [_vm._v(" Seleccionar ")]
                      )
                    ],
                    1
                  )
                ]
              )
            }),
            0
          )
        ],
        1
      ),
      _vm.students.length === 0 && _vm.searched
        ? _c("custom-separator", {
            staticClass: "pt-3 my-4",
            attrs: { text: "Resultado de Búsqueda" }
          })
        : _vm._e(),
      _vm.students.length === 0 && _vm.searched
        ? _c(
            "div",
            { staticClass: "bg-white rounded pt-1 pb-3" },
            [
              _c("custom-result-not-found", {
                attrs: { text: "Su búsqueda no produjo resultado." }
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }